export type MstpEndpointsType = {
  getSmtp: string;
  editSmtp: string;
};

export const smtpEndpoints: MstpEndpointsType = {
  getSmtp: "smtp",
  editSmtp: "smtp",
};
